import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import { Body } from '../../styled components/Typography';
import { UIBar, UIBarGrowItem } from '../../styled components/UIBar';
import { WidgetsList, WidgetsListItem, WidgetsListItemCard } from './WidgetList.style';
import DateNavigationUrlWrapper from '../DateNavigationUrlWrapper';
import debounce from '../../libs/debounce';
import NavigationHistory from '../../libs/NavigationHistory';
import { capture, phWidgetClicked } from '../../libs/posthogAnalytics';

export default function WidgetList({
  navs = [],
  navigationHistory,
  humanResource = null,
  linkUrlFor
}) {
  const widgetsToRender = navs.filter((widget) => !widget.internal);
  /* Special case for the roster and events widget: transform /widgetname to /widgetname/week-xx-yyyy#dd-mm-yyyy */
  const linkForWidget = (widget) => {
    if (['events', 'roster', 'timesheets'].includes(widget.id)) {
      const { dateObject, week } =
        DateNavigationUrlWrapper.getDateAndWeekFromUrlPartsOrFromCurrentDate(false);
      return `${linkUrlFor(
        widget.linkTo
      )}${DateNavigationUrlWrapper.getWeekAndDayPatternUrl(week, dateObject)}`;
    }
    return linkUrlFor(widget.linkTo);
  };

  const goToWidget = (widget) => {
    capture(phWidgetClicked(widget.id));
    navigationHistory.goTo(linkForWidget(widget, linkUrlFor));
  };
  const debouncedGoToWidget = useCallback(debounce(goToWidget), []);
  const rows = widgetsToRender.map((widget) => {
    if (
      humanResource === null &&
      ['roster', 'timesheets', 'timesheet'].some((widgetName) => widget.id === widgetName)
    )
      return null;
    if (widget.id === 'timesheets' && !humanResource.usetimesheets) return null;
    return (
      <WidgetsListItem key={widget.id}>
        <WidgetsListItemCard
          onClick={() => {
            debouncedGoToWidget(widget);
          }}
        >
          <UIBar tw="pl-4 pr-4">
            <div tw="truncate">
              <Body as="span" $color="black">
                {i18n(widget.nameMessage)}
              </Body>
            </div>
            <UIBarGrowItem />
            <Button contentType="icon" size="small" icon="navigate-next" />
          </UIBar>
        </WidgetsListItemCard>
      </WidgetsListItem>
    );
  });

  return <WidgetsList data-test-widgetslist>{rows}</WidgetsList>;
}

WidgetList.propTypes = {
  navs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      nameMessage: PropTypes.string,
      linkTo: PropTypes.string
    })
  ),
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired,
  humanResource: PropTypes.shape({}),
  linkUrlFor: PropTypes.func.isRequired
};
